import { EventEmitter } from '@angular/core';
var BranchSelectorComponent = /** @class */ (function () {
    function BranchSelectorComponent() {
        this.title = '¿Que querés cotizar?';
        this.onClick = new EventEmitter();
    }
    BranchSelectorComponent.prototype.handleOnClick = function (event) {
        this.onClick.emit(event);
    };
    return BranchSelectorComponent;
}());
export { BranchSelectorComponent };
